// src/components/shared/BackToolbarLink.js
// Toolbar "Back" button used in drill-down sub-page tables (matches
// AddToolbarLink's visual style so the two read as a pair when shown
// side-by-side in the same toolbar).
//
// Usage:
//   renderTopToolbarCustomActions={() => (
//     <Box sx={{ display: "flex", alignItems: "center" }}>
//       <BackToolbarLink onClick={() => navigate(-1)} />
//       <AddToolbarLink to="/AddConnectionCmd" label="Add Command" state={dataParams} />
//     </Box>
//   )}

import React from "react";
import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

const BackToolbarLink = ({ onClick, to, label = "Back" }) => {
  const navigate = useNavigate();

  const handleClick = onClick || (() => (to ? navigate(to) : navigate(-1)));

  return (
    <Button
      variant="text"
      color="primary"
      size="small"
      startIcon={<ArrowBackIcon fontSize="small" />}
      onClick={handleClick}
      sx={{ fontWeight: 500, "&:hover": { bgcolor: "action.hover" } }}
    >
      {label}
    </Button>
  );
};

export default BackToolbarLink;
